import React from 'react'

const BlueWave = () => {
  return (
    <div className='m-0 p-0' style={{ lineHeight: 0, width: '100%', overflow: 'hidden' }}>
      <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: '100%', height: 'auto', display: 'block', transform: 'translateY(1px)' }}>
        <path d="M0,32L120,42.7C240,53,480,75,720,74.7C960,75,1200,53,1320,42.7L1440,32L1440,120L1320,120C1200,120,960,120,720,120C480,120,240,120,120,120L0,120Z" fill="var(--highlight-color)" />
      </svg>
    </div>
  )
}

export default BlueWave
